import { z } from 'zod';

import type { DocumentFileLink } from '#domain/Document.ts';
import { apiRootDocuments } from '#store/apiDocumentsRoot.ts';

import { mapDocumentFileLink } from './adapters/documentAdapter.ts';
import { validateWarn } from './validateZodHelper.ts';

const url = '/documents';
const TAG = 'DOCUMENTS';

type QueryArgs = { documentId: string; fileName: string };

const fileLinkSchema = z.object({ url: z.string() }).passthrough();
const documentFileUrl = ({ documentId, fileName }: QueryArgs) =>
    `${url}/${encodeURIComponent(documentId)}/file/${encodeURIComponent(fileName)}`;

export const documentLinkApiSlice = apiRootDocuments.injectEndpoints({
    endpoints: build => ({
        downloadLink: build.query<DocumentFileLink, QueryArgs>({
            query: args => ({
                url: documentFileUrl(args),
            }),
            providesTags: [TAG],
            transformResponse: (response, meta, arg) =>
                mapDocumentFileLink(validateWarn(fileLinkSchema)(response, meta, arg)),
        }),
        uploadLink: build.mutation<DocumentFileLink, QueryArgs>({
            query: args => ({
                url: documentFileUrl(args),
                method: 'POST',
            }),
            transformResponse: (response, meta, arg) =>
                mapDocumentFileLink(validateWarn(fileLinkSchema)(response, meta, arg)),
        }),
    }),
});

export const { useDownloadLinkQuery, useUploadLinkMutation } = documentLinkApiSlice;
